import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-shell min-h-screen flex items-center justify-center bg-[#0A0A0C] px-6">
      <div className="w-full max-w-md">
        <p className="overline mb-6">Artistry Perspectives</p>
        <h1 className="font-display text-4xl md:text-5xl tracking-tighter leading-none mb-12">
          Admin <span className="font-serif-accent text-[#C9A050]">access</span>
        </h1>

        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-6">
          <div>
            <label className="overline block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              required
              className="w-full bg-transparent border-b border-white/15 focus:border-[#C9A050] outline-none py-3 text-white"
            />
          </div>
          <div>
            <label className="overline block mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              required
              className="w-full bg-transparent border-b border-white/15 focus:border-[#C9A050] outline-none py-3 text-white"
            />
          </div>
          {err && <p data-testid="login-error" className="text-red-400 text-sm">{err}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full mt-6 border border-white/20 hover:border-[#C9A050] hover:text-[#C9A050] text-white overline py-4 transition-all"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="mt-12 text-xs text-[#8A8A93]">
          Default: <span className="text-white/70">admin@studio.com</span> / <span className="text-white/70">Studio@2025</span>
        </p>
      </div>
    </div>
  );
}
